// @ts-ignore
import moment from 'moment';

export function todayMidnight() {
  return moment().startOf('day');
}

